import Image from 'components/Basic/Image/Image';
import useTranslation from 'next-translate/useTranslation';
import twMerge from 'utils/twMerge';

type StoreBenefitsProps = {
    acceptGiftCoupon: boolean;
    hasLoyaltyProgram: boolean;
    isPickupPoint: boolean;
    acceptGiftCouponIcon: string | null;
    hasLoyaltyProgramIcon: string | null;
    isPickupPointIcon: string | null;
    isInline?: boolean;
};

const TEST_IDENTIFIER = 'blocks-store-storebenefits';

const StoreBenefits: FC<StoreBenefitsProps> = ({
    isInline = true,
    hasLoyaltyProgram,
    hasLoyaltyProgramIcon,
    isPickupPoint,
    isPickupPointIcon,
    acceptGiftCoupon,
    acceptGiftCouponIcon,
}) => {
    const { t } = useTranslation();
    const renderPlaceholder = (condition: boolean) => {
        if (condition && isInline) {
            return <li aria-hidden className="h-[30px] w-[30px]" role="presentation" />;
        }

        return null;
    };

    return (
        <ul
            data-testid={TEST_IDENTIFIER}
            className={twMerge(
                'text-[15px] vl:text-body',
                isInline
                    ? 'flex [&>li+li]:ml-[18px] [&_img]:h-[30px] [&_img]:w-[30px]'
                    : 'my-5 [&>li]:mb-[18px] [&>li]:flex [&>li]:items-center [&_img]:h-10 [&_img]:w-10 [&_picture]:mr-[18px]',
            )}
        >
            {hasLoyaltyProgram && hasLoyaltyProgramIcon && (
                <li className="flex gap-2">
                    <Image
                        alt={t('Tescoma club')}
                        height="28"
                        src={hasLoyaltyProgramIcon}
                        title={t('Tescoma club')}
                        width="43"
                    />
                    {!isInline && t('Tescoma club')}
                </li>
            )}
            {renderPlaceholder(!hasLoyaltyProgram || !hasLoyaltyProgramIcon)}
            {isPickupPoint && isPickupPointIcon && (
                <li className="flex gap-2">
                    <Image
                        alt={t('E-shop collection point')}
                        height="28"
                        src={isPickupPointIcon}
                        title={t('E-shop collection point')}
                        width="43"
                    />
                    {!isInline && t('E-shop collection point')}
                </li>
            )}
            {renderPlaceholder(!isPickupPoint || !isPickupPointIcon)}
            {acceptGiftCoupon && acceptGiftCouponIcon && (
                <li className="flex gap-2">
                    <Image
                        alt={t('Possibility to use gift vouchers')}
                        height="28"
                        src={acceptGiftCouponIcon}
                        title={t('Possibility to use gift vouchers')}
                        width="43"
                    />
                    {!isInline && t('Possibility to use gift vouchers')}
                </li>
            )}
            {renderPlaceholder(!acceptGiftCoupon || !acceptGiftCouponIcon)}
        </ul>
    );
};

export default StoreBenefits;
